import * as angular from 'angular';

import { ContextualField, Identifier, Group, SelectionStrategy, IValueViewModel, ObjectType, IdentifierType } from '../../../../models/index';
import * as Fields from '../../../../common/helpers/contextual';
import { getCommonProperties } from './commonProperties';
import { targetProperty } from './targetProperty';
import { linkedGuidProperty } from './linkedGuidProperty';
import { tagDefinitionGuidProperty } from './tagDefinitionGuidProperty';

const valueTypeProperty = angular.copy(Fields.ValueType);
const selectionStrategyProperty = angular.copy(Fields.SelectionStrategy);

const targetProperties: ContextualField[] = getCommonProperties()
    .concat([
        selectionStrategyProperty,
        linkedGuidProperty,
        tagDefinitionGuidProperty,
        valueTypeProperty,
        targetProperty
    ]);

export function getTargetProperties(selectedItem: Identifier, group: Group): ContextualField[] {
    const properties = targetProperties;
    const selectionStrategyProperty = targetProperties.find(property => property.propertyName === 'selectionStrategyProperty');
    if (selectionStrategyProperty?.extraData?.options && selectionStrategyProperty.extraData.options.length > 2) {
        selectionStrategyProperty.extraData.options = selectionStrategyProperty.extraData.options.slice(1, 3);
    }
    valueTypeProperty.extraData.selectionStrategy = selectedItem.selectionStrategy;
    linkedGuidProperty.hide = selectedItem.selectionStrategy !== SelectionStrategy.Calculated;
    tagDefinitionGuidProperty.hide = selectedItem.selectionStrategy !== SelectionStrategy.Tags;
    selectionStrategyProperty.onChange = value => {
        valueTypeProperty.extraData.selectionStrategy = value;
        linkedGuidProperty.hide = value !== SelectionStrategy.Calculated;
        tagDefinitionGuidProperty.hide = value !== SelectionStrategy.Tags;
    };
    tagDefinitionGuidProperty.extraData.filter = (list: IValueViewModel[]) => list.filter(l => l.objectType === ObjectType.Tag);
    linkedGuidProperty.extraData.filter = (list: IValueViewModel[]) => list.filter(l => l.objectType === ObjectType.Identifier
        && l.identifierType === IdentifierType.CalculatedValue);
    return properties;
}